import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["turboFrame"]
  static values = { param: String, path: String }

  refresh({ target }) {
    const request = new Request(this.pathValue) // This is needed to transform the path to a URL.
    const url = new URL(request.url)
    url.searchParams.set(this.paramValue, target.value)

    this.turboFrameTarget.setAttribute("src", url)
  }
}
